let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iHosq")).then(() => parcelRequire('2DUOs'));